import { z } from 'zod'
import { http } from './http'
import { auth } from './auth'
import { FileMatchSchema } from '../schemas'
import { parseWithZod } from '../utils/parse-with-zod'

const FileMatchesResponseSchema = z.object({
  file_matches: z.array(FileMatchSchema),
})

export const fileMatches = {
  fetchFileMatches: async (dealId: number) => {
    const regionHost = auth.getUserRegionHost()
    const result = await http.get(
      `${regionHost}/api/deals/${dealId}/file_matches`,
      undefined,
      dealId,
    )
    return parseWithZod(FileMatchesResponseSchema, result).file_matches
  },

  deleteFileMatch: async (fileMatchId: number, dealId: number) => {
    const regionHost = auth.getUserRegionHost()
    return await http.delete(`${regionHost}/api/file_matches/${fileMatchId}`, dealId)
  },
}
